import TableContainer from "components/Common/TableContainer";
import React, { useMemo } from "react"
import {
  Container,
} from "reactstrap"
import ListPerizie from "./ListPerizie";

const Perizie = () => {
  //meta title
  document.title=`Lista Perizie | ${process.env.REACT_APP_DOCUMENT_NAME}`;

  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <ListPerizie /> 
      </Container>
    </div>
  </React.Fragment>
  );
}

export default Perizie;
